export const EVENTS = {
  INBOUND_CALLING: 'inbound_calling',
  INBOUND_FORM_SUBMITTED: 'inbound_form_submitted',
  RC_CALLING: 'rc_calling',
};
